import { isNotSet } from './isNotSet';

/**
 * Extracts metadata from a trigger block, detecting whether it uses a "not" condition.
 *
 * - If the block uses the "not" method (`isNotSet` returns true), it assumes the real source block
 *   is stored in the first `fields[0].value`.
 * - Otherwise, it uses the block itself as the source data.
 *
 * @param {Object} block - A MeshBot trigger block to analyze.
 * @param {Array<Object>} [block.fields] - Optional array of fields, used if block is negated.
 * @returns {{
 *   isNotBlock: boolean,
 *   sourceData: Object | undefined
 * }} An object containing a boolean flag and the resolved source block (either `block` or `block.fields[0].value`).
 *
 * @example
 * getTriggerBlockData(block); // ➜ { isNotBlock: true, sourceData: {...} }
 */
export const getTriggerBlockData = (block) => {
    const isNotBlock = isNotSet(block);
    const sourceData = isNotBlock ? block.fields?.[0]?.value : block;

    return {
        isNotBlock,
        sourceData,
    };
};
